import React, { useState } from 'react';
import './SipCalculator.css'; // Import the CSS file
import SipCalculatorPic from "../resources/sip-calculator.png"; // Import the CSS file

const SipCalculator = () => {
  const [monthlyInvestment, setMonthlyInvestment] = useState(1000);
  const [annualReturnRate, setAnnualReturnRate] = useState(1);
  const [investmentDuration, setInvestmentDuration] = useState(1);
  const [maturityAmount, setMaturityAmount] = useState(0);

  const calculateSip = () => {
    const monthlyRate = annualReturnRate / 12 / 100;
    const totalMonths = investmentDuration * 12;
    const maturity =
      monthlyInvestment *
      ((Math.pow(1 + monthlyRate, totalMonths) - 1) / monthlyRate) *
      (1 + monthlyRate);

    setMaturityAmount(maturity.toFixed(2));
  };

  return (
    <div className='page financial-calculator-page'>
      <div className="calculator-container">
        <div className="sip-calculator">
          <h3 className='heading'>SIP Calculator</h3>

          <div className="input-container">
            <label>
              <div className="label-container">
                <p>Monthly Investment (₹):</p>
                <b>₹ {monthlyInvestment}</b>
              </div>
              <input
                type="range"
                min="1000"
                max="50000"
                step="500"
                value={monthlyInvestment}
                onChange={(e) => setMonthlyInvestment(Number(e.target.value))}
                className="input-range"
              />
            </label>
          </div>

          <div className="input-container">
            <label>
              <div className="label-container">
                <p>Annual Return Rate (%):</p>
                <b>{annualReturnRate}%</b>
              </div>
              <input
                type="range"
                min="1"
                max="20"
                step="0.1"
                value={annualReturnRate}
                onChange={(e) => setAnnualReturnRate(Number(e.target.value))}
                className="input-range"
              />
            </label>
          </div>

          <div className="input-container">
            <label>
              <div className="label-container">
                <p>Investment Duration (Years):</p>
                <b>{investmentDuration} years</b>
              </div>
              <input
                type="range"
                min="1"
                max="30"
                step="1"
                value={investmentDuration}
                onChange={(e) => setInvestmentDuration(Number(e.target.value))}
                className="input-range"
              />
            </label>
          </div>

          <button onClick={calculateSip} className="button">
            Calculate
          </button>


          <div className="result-container">
            <h4>Maturity Amount</h4>
            <p>₹ {maturityAmount}</p>
          </div>

        </div>
        <img src={SipCalculatorPic} alt="Calculator Illustration" />
      </div>
    </div>
  );
};

export default SipCalculator;
